import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/PostNord@2x.png")